import { render, staticRenderFns } from "./CommentConfirm.vue?vue&type=template&id=12d56793&scoped=true"
import script from "./CommentConfirm.vue?vue&type=script&lang=js"
export * from "./CommentConfirm.vue?vue&type=script&lang=js"
import style0 from "./CommentConfirm.vue?vue&type=style&index=0&id=12d56793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d56793",
  null
  
)

export default component.exports